<div class="container-narrow">
  <!-- PAGE TITLE AND FILTERS -->
  <div class="row my-4">
    <div class="col-12">

      <div class="d-flex align-items-center">
        <a [routerLink]="['/']"
           class="dvi-themed-text-color py-2 ps-0 pe-2 border-0">
          <i-feather name="arrow-left"></i-feather>
          <span class="visually-hidden"
                [translate]="'SALON-SEARCH-RESULTS.BUTTON-GO-BACK'"></span>
        </a>
        <h1 class="m-0 h4 fw-bolder dvi-themed-text-color notranslate"
        >{{ formattedPageTitle }}</h1>
      </div>

      <ng-container *ngIf="!searchResults.matchesInCityFound && searchResults.matchesNearbyFound">
        <!-- DESCRIPTION -->
          <div class="text-secondary">
            <ng-container *ngIf="searchResults.department; else onlyCity">
              <span [translate]="'SALON-SEARCH-RESULTS.RESULTS-DESCRIPTION-SCENARIOS.CITY-AND-DEPARTMENT-NEARBY'"
                    [translateParams]="{cityName: searchResults.cityName, departmentName: searchResults.department.name}"></span>
            </ng-container>
            <ng-template #onlyCity>
              <span [translate]="'SALON-SEARCH-RESULTS.RESULTS-DESCRIPTION-SCENARIOS.ONLY-CITY-NEARBY'"
                    [translateParams]="{cityName: searchResults.cityName}"></span>
            </ng-template>
        </div>
      </ng-container>

      <div class="d-flex align-items-center">
          <ng-container *ngIf="searchResults.resultsList && searchResults.resultsList.length > 0">
            <div class="invisible pe-2">
              <i-feather name="arrow-left"></i-feather>
            </div>
            <span class="text-secondary">
                <span [translate]="'SALON-SEARCH-RESULTS.AMOUNT-OF-SALONS-FOUND'"
                      [translateParams]="{amountOf: searchResults.resultsList.length}"></span>
            </span>
          </ng-container>
          <ng-container *ngIf="searchResults.resultsList && searchResults.resultsList.length === 0 && searchResults.matchesNearbyFound">
            <span class="text-secondary">
              <div class="mt-4 mb-4">
                <span [translate]="'SALON-SEARCH-RESULTS.NO-SALONS-FOUND-IN-CITY'"
                      [translateParams]="{cityName: searchResults.cityName}"></span>
              </div>
            </span>
          </ng-container>
      </div>

      <ng-container *ngIf="!searchResults.matchesInCityFound && searchResults.matchesNearbyFound">
        <!-- NEARBY RESULTS LIST -->
        <div>
          <app-salons-search-results-item *ngFor="let item of searchResults.nearbyResultsList"
                                          [item]="item"
                                          [cityName]="searchResults.cityName">
          </app-salons-search-results-item>
        </div>
      </ng-container>

    </div>
  </div>

  <ng-container *ngIf="!searchResults.matchesInCityFound && !searchResults.matchesNearbyFound">
    <div class="row mt-4">
      <div class="col-12 text-secondary">
          <span [translate]="'SALON-SEARCH-RESULTS.NO-SALONS-FOUND-IN-CITY-OR-NEARBY'"
                [translateParams]="{cityName: searchResults.cityName}"></span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="searchResults.matchesInCityFound">
    <!-- DESCRIPTION -->
    <div class="row mt-4">
      <div class="col-12 text-secondary">
        <ng-container *ngIf="searchResults.department; else onlyCity">
          <span [translate]="'SALON-SEARCH-RESULTS.RESULTS-DESCRIPTION-SCENARIOS.CITY-AND-DEPARTMENT'"
                [translateParams]="{cityName: searchResults.cityName, departmentName: searchResults.department.name}"></span>
        </ng-container>
        <ng-template #onlyCity>
          <span [translate]="'SALON-SEARCH-RESULTS.RESULTS-DESCRIPTION-SCENARIOS.ONLY-CITY'"
                [translateParams]="{cityName: searchResults.cityName}"></span>
        </ng-template>
      </div>
    </div>

    <!-- RESULTS LIST -->
    <div class="row mt-5">
      <div class="col-12">
        <app-salons-search-results-item *ngFor="let item of searchResults.resultsList"
                                        [item]="item">
        </app-salons-search-results-item>
      </div>
    </div>
  </ng-container>
</div>
